import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "15",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M2.4 14.904.548 13.052l5.6-5.6-5.6-5.6L2.4 0 8 5.6 13.6 0l1.852 1.852-5.6 5.6 5.6 5.6-1.852 1.852-5.6-5.6z" }, null, -1)
  ])))
}
export default { render: render }